export interface Category {
  slug: string;
  label: string;
  blurb: string;
}

export const CATEGORIES: Category[] = [
  {
    slug: "subject-explainers",
    label: "Explainers",
    blurb:
      "Core concepts unpacked with Indian examples, economics-forward, but written for anyone who reads a textbook and still feels lost.",
  },
  {
    slug: "exam-strategy",
    label: "Exam Strategy",
    blurb:
      "Reading question papers, allocating time, and where marks actually get lost. Focused on Delhi University and comparable Indian universities.",
  },
  {
    slug: "study-systems",
    label: "Study Systems",
    blurb:
      "Timetables you'll actually follow, active recall for theory-heavy subjects, and notes that pull their weight at revision time.",
  },
  {
    slug: "college-life",
    label: "College Life",
    blurb:
      "Honours vs Programme, attendance rules, campus geography, and everything nobody bothers to explain to first-years.",
  },
  {
    slug: "careers",
    label: "Careers",
    blurb:
      "What economics undergrads actually do after DU, and how to think about CAT, civil services, and a master's before third year sneaks up.",
  },
  {
    slug: "news",
    label: "News",
    blurb:
      "Delhi University admissions, Academic Council decisions, and campus policy shifts, reported plainly and put in context for students.",
  },
];

export function categoryBySlug(slug: string): Category | undefined {
  return CATEGORIES.find((c) => c.slug === slug);
}